import classnames from 'classnames';
import React, { FC, ReactNode } from 'react';
import { MainSource, Source } from '../../../../../constants/Source';
import { MediaManagerSDKFolder } from '../../../../../utils/media-manager-sdk';
import { isBoard } from '../../../../../utils/media-manager-sdk/boards';
import { isRootFolder } from '../../../../../utils/media-manager-sdk/items';
import { FolderThumbnail } from '../../../../../components/common';
import { Board } from '../Thumbnails/Board';
import styles from './NoItemsTopPart.scss';
import { IOuter } from './NoItemsTopPart.types';

const iconBySource = (source: Source, currentFolder: MediaManagerSDKFolder): ReactNode => {
  switch (source) {
    case MainSource.SiteFiles:
      return <div className={classnames(styles.thumbnail, styles.siteFiles)} />;

    case MainSource.Trash:
      return <div className={classnames(styles.thumbnail, styles.trash)} />;

    case MainSource.Favorites:
      return <div className={classnames(styles.thumbnail, styles.favorites)} />;

    case MainSource.VisitorsUploads:
      return <div className={classnames(styles.thumbnail, styles.visitorUploads)} />;

    case MainSource.Boards:
      return <div className={classnames(styles.thumbnail, styles.boards)} />;

    default:
      return <FolderThumbnail folder={currentFolder} />;
  }
};

export const NoItemsTopPart: FC<IOuter> = ({ currentFolder, source }) => (
  <div className={styles.wrapper} data-hook="root-folder-thumbnail">
    <div className={classnames(styles.inner, { [styles.innerBoard]: isBoard(currentFolder) })}>
      {isBoard(currentFolder) ? (
        <Board item={currentFolder} />
      ) : isRootFolder(currentFolder) ? (
        iconBySource(source, currentFolder)
      ) : (
        <FolderThumbnail folder={currentFolder} />
      )}
    </div>
  </div>
);
